// constants.ts - constantes locales de la landing (hors domaine métier).
import { APP_STORE_URL, PLAY_STORE_URL, SUPPORT_EMAIL, SUPPORT_TEL } from "@hop-resto/shared";

/** URL canonique du site en production. */
export const SITE_URL = "https://hop-resto.web.app";

/**
 * Fiches des stores (app publiée le 21 septembre 2026) - ré-exportées depuis
 * `@hop-resto/shared`, source unique partagée avec la page web restaurateur.
 * Le hero affiche désormais DEUX vrais boutons de téléchargement, à la place
 * de l'ancien badge « Bientôt sur vos smartphones ».
 */
export { APP_STORE_URL, PLAY_STORE_URL };

/**
 * Contact restaurateur (6 septembre 2026) : le formulaire « Être recontacté »
 * a été retiré de la landing - un restaurateur écrit directement. Même
 * adresse que celle affichée dans la PWA (Paramètres → Aide) et sur les pages
 * légales : `SUPPORT_EMAIL` est la source unique.
 */
export const CONTACT_EMAIL = SUPPORT_EMAIL;
export const CONTACT_MAILTO = `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(
  "Hop Resto - mon restaurant",
)}`;

// ── Informations légales - À COMPLÉTER avant diffusion large ──────────────
// Ces valeurs alimentent les pages Mentions légales et Confidentialité.
export const LEGAL = {
  /** Nom / raison sociale de l'éditeur du site. */
  editeur: "Hop Resto",
  /** Statut (ex. « auto-entrepreneur », « SAS au capital de … »). */
  statut: "statut juridique en cours de constitution",
  /** Adresse postale de l'éditeur. */
  adresse: "Compiègne",
  /**
   * Email de contact public - repris de `SUPPORT_EMAIL` (@hop-resto/shared),
   * la MÊME adresse que celle affichée aux restaurateurs dans la PWA
   * (Paramètres → Aide). Une seule source : deux copies finissent toujours par
   * diverger, et c'est l'adresse à laquelle on écrit pour exercer ses droits.
   */
  email: SUPPORT_EMAIL,
  /** Téléphone de contact public - même source que l'email. */
  telephone: SUPPORT_TEL,
  /** Directeur de la publication. */
  directeur: "Hop Resto",
  /** Durée de conservation des demandes de contact restaurateurs. */
  dureeConservationLeads: "12 mois",
  /**
   * Conservation de l'historique nominal des réservations confirmées.
   * ⚠️ DOIT rester aligné sur `RESERVATION_RETENTION_ANNEES` (3) dans
   * `packages/shared/src/constants.ts` : c'est la durée réellement appliquée
   * par la fonction d'anonymisation (docs/rules/historique-reservations.md).
   */
  dureeHistorique: "3 ans",
  // ── Conditions commerciales (CGV) - à valider avant diffusion ──
  /** Périodicité de facturation de l'abonnement restaurateur. */
  periodiciteFacturation: "mensuelle",
  /** Préavis avant toute évolution tarifaire. */
  preavisTarifaire: "un mois",
  /** Préavis de résiliation de l'abonnement. */
  preavisResiliation: "30 jours",
  /** Durée pendant laquelle l'export des données reste possible après résiliation. */
  dureeReversibilite: "30 jours",
} as const;

/** Une valeur légale est-elle encore un placeholder ? (affichage surligné) */
export function isPlaceholder(v: string): boolean {
  return v.startsWith("[");
}
